<template>
  <div class="flex-column comm-wrapper testpaper2">
    <el-collapse v-model="activeNames" class="col-1">
      <el-collapse-item name="沟通日志">
        <template slot="title">
          <span class="collapse-item-title">沟通日志</span>
          <peixun type="3" style="display:inline-block;margin-left:10px;position:relative;top:1px"></peixun>
        </template>
        <div class="testpaper-textarea pd-10 mb10">
          <el-input
            v-model="otherRemark"
            :rows="2"
            :autosize="{ minRows: 2 }"
            type="textarea"
            placeholder="填写沟通日志"
            @input="autoSaveRemarkLocal"
          />
          <el-button
            type="primary"
            size="mini"
            style="position:absolute;right:10px;bottom:0"
            @click="save({ only: true })"
            >保存日志</el-button
          >
        </div>
        <div class="mb10 pd-10">
          <a href="javascript:void(0);" class="follow_drawer_btn mr10" @click="showFollow">待跟进</a>
          <a href="javascript:void(0);" class="follow_drawer_btn mr10" @click="showRec">推荐给他人</a>
          <div class="radish-act-grp" style="float:right;font-size:14px;color:#666">
            只看自己的<el-switch v-model="myOnly"></el-switch>
          </div>
          <div class="radish-act-grp" style="float:right;font-size:14px;color:#666">
            只展示沟通记录<el-switch v-model="gouOnly"></el-switch>
          </div>
        </div>
        <div v-if="remark" class="pd-10 relate-div">
          <waterMark :num="8"></waterMark>
          <div
            v-for="(item, index) in remarks"
            :key="index"
            class="remark-item relate-div"
            :class="item && item.owner === user ? 'remark-self' : ''"
          >
            <template>
              <div v-if="item.owner === 'FA公司竞合'" class="remark-date" style="color: rgb(239, 141, 45) !important;">
                {{ item.date }}
                <span v-if="item.owner" class="remark-time" style="color: rgb(239, 141, 45) !important;">{{
                  item.time
                }}</span>
                -- {{ item.owner }}
              </div>
              <div v-else class="remark-date">
                {{ item.date }} <span v-if="item.owner" class="remark-time">{{ item.time }}</span> -- {{ item.owner }}
              </div>
            </template>
            <template v-for="(remarkItem, _index) in remarkGroup[item.group]">
              <div v-if="(!myOnly || item.owner === user) && (!gouOnly || remarkItem.stem == '沟通记录')" :key="_index" class="remark-info">
                <!-- <i v-if="remarkItem.stem == '沟通记录'" class="el-icon-question"> 沟通记录 </i> -->
                <i class="el-icon-info" /> <span v-html="formatAnswer(remarkItem.answer)"></span>
                <i class="el-icon-delete" @click="removeRemark(remarkItem)" />
              </div>
            </template>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="通用问题">
        <template slot="title">
          <span class="collapse-item-title">通用问题</span>
        </template>
        <div
          v-for="(item, _index) in testPaper.common"
          v-show="!item.hidden"
          :key="_index"
          :ref="`question${_index}`"
          class="question"
        >
          <div class="stem">
            {{ _index }}） {{ item.stem }}{{ questionType[item.type] ? `（${questionType[item.type]}）` : '' }}
          </div>
          <div v-if="item.type === 'radio' || item.type === 'multible'" class="flex-column">
            <div
              v-for="(option, key) in item.options"
              :key="key"
              class="question-option"
              @click="onSelect(item, key, _index)"
            >
              <i
                :class="
                  `el-icon-check check-icon ${
                    (Array.isArray(item.answer) && item.answer.includes(key)) || item.answer === key ? 'check-blue' : ''
                  }`
                "
              />
              {{ key }}、{{ option }}
            </div>
            <div v-if="Object.keys(item).includes('text')">
              <label>{{ item.textLabel || '其他备注' }}:</label>
              <el-input
                v-model="item.text"
                type="textarea"
                autosize
                @change="val => onChanges({ item, text: val }, 'common')"
              />
            </div>
          </div>
          <div v-else-if="item.type === 'input'">
            <el-input
              v-model="item.text"
              type="textarea"
              autosize
              @change="val => onChanges({ item, text: val }, 'common')"
            />
          </div>
          <div v-else-if="item.type === 'sort'" class="sort-box">
            <span v-for="(tag, index) in item.options" :key="tag" class="sort-tag pointer" @click="addTag(item, tag)">
              <el-tag size="small" class="mb5">{{ index + 1 }} {{ tag }}</el-tag>
            </span>
            <div v-if="Object.keys(item).includes('text')">
              <label>{{ item.textLabel || '其他备注' }}:</label>
              <el-input
                v-model="item.text"
                type="textarea"
                autosize
                @change="val => onChanges({ item, text: val }, 'common')"
              />
            </div>
            <div class="sort-result pd-10">
              <div>排序结果：</div>
              <el-tag
                v-for="(_tag, _index) in item.answer"
                :key="_tag"
                closable
                class="mr10"
                size="small"
                @close="removeTag(item, _tag)"
                >{{ _index + 1 }} {{ _tag }}</el-tag
              >
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item v-for="(category, index) in radish['职能模块']" :key="category" :name="index + 1">
        <template slot="title">
          <span class="collapse-item-title">{{ `《${category}》问题` }}</span>
        </template>
        <div v-for="(_item, _index) in testPaper[category]" :key="_index" class="question">
          <div class="stem">
            {{ _index }}） {{ _item.stem }}{{ questionType[_item.type] ? `（${questionType[_item.type]}）` : '' }}
          </div>
          <div v-if="_item.type === 'radio' || _item.type === 'multible'" class="flex-column">
            <div
              v-for="(option, key) in _item.options"
              :key="key"
              class="question-option"
              @click="onSelect(_item, key)"
            >
              <i
                :class="
                  `el-icon-check check-icon ${
                    (Array.isArray(_item.answer) && _item.answer.includes(key)) || _item.answer === key
                      ? 'check-blue'
                      : ''
                  }`
                "
              />
              {{ key }}、{{ option }}
            </div>
            <el-input
              v-if="Object.keys(_item).includes('text')"
              v-model="_item.text"
              type="textarea"
              autosize
              @change="val => onChanges({ item: _item, text: val }, category)"
            />
          </div>
          <div v-else-if="_item.type === 'input'">
            <el-input
              v-model="_item.text"
              type="textarea"
              autosize
              @change="val => onChanges({ item: _item, text: val }, category)"
            />
          </div>
          <div v-else-if="_item.type === 'sort'" class="sort-box flex-row flex-wrap">
            <span v-for="(tag, index) in _item.options" :key="tag" class="sort-tag pointer" @click="addTag(_item, tag)">
              <el-tag size="small" class="mb5">{{ index + 1 }} {{ tag }}</el-tag>
            </span>
            <div class="sort-result pd-10">
              <div>排序结果：</div>
              <el-tag
                v-for="(_tag, _index) in _item.answer"
                :key="_tag"
                closable
                class="mr10"
                size="small"
                @close="removeTag(_item, _tag)"
                >{{ _index + 1 }} {{ _tag }}</el-tag
              >
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="个性标签">
        <template slot="title">
          <span class="collapse-item-title">个性标签</span>
        </template>
        <div v-for="(tagGroup, index) in tags" :key="index" class="question">
          <div>{{ tagGroup.label }}</div>
          <div v-if="tagGroup.key === 'other'">
            <el-tag v-for="tag in tagGroup.checkList" :key="tag" closable size="small" @close="removeOtherTag(tag)">{{
              tag
            }}</el-tag>
            <el-input
              v-if="inputVisible"
              ref="saveTagInput"
              v-model="inputValue"
              class="input-new-tag"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            />
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
          </div>
          <el-checkbox-group v-model="tagGroup.checkList" velse class="flex-row flex-wrap" @change="onTagchange">
            <el-checkbox v-for="tag in tagGroup.children" :key="tag" :label="tag" class="col-0 mr10" />
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>
    <followDialog ref="followDialog" /> <recDialog ref="recDialog" />
  </div>
</template>

<script>
import { zhijiOptionKey, yejiOptionKey, formatYeji, formatZhiji, questionType } from '../constant/type'
import { tags } from '../constant/tags'
import { getQuestions } from '../constant/questions'
import { arrRemove } from '../../../project/src/constant/utils'
import followDialog from './followDialog'
import recDialog from './recDialog'

const dateFormat = require('dateformat')
// TODO refactor
export default {
  components: {
    followDialog,
    recDialog,
  },
  props: {
    radish: {
      type: Object,
      default: () => ({}),
    },
    onSave: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      answerCardModal: {},
      testPaper: {},
      changes: {},
      remark: [],
      otherRemark: '',
      activeNames: [
        '沟通日志',
        '通用问题',
        // '个性标签', 1, 2, 3, 4
      ],
      // percentage: 0,
      linkChanges: [],
      tags: _.cloneDeep(tags),
      remarkGroup: {},
      inputVisible: false,
      inputValue: '',
      gouOnly: false,
      myOnly: false,
    }
  },
  computed: {
    questionType() {
      return questionType
    },
    remarks() {
      const remarkGroup = this.remarkGroup
      const groups = Object.keys(remarkGroup)
      const sorted = groups.reverse()
      const result = sorted.map(v => {
        const parsed = v.split('--')
        const dateTime = (parsed[0] && parsed[0].split(' ')) || []
        return {
          date: dateTime[0],
          time: dateTime[1],
          owner: parsed[1],
          group: v,
          sort: new Date(parsed[0]).getTime(),
        }
      })
      console.log('🚀 ~ file: TestPaper2.vue ~ line 292 ~ remarks ~ result', result)
      return result.sort((a, b) => b.sort - a.sort)
    },
    user() {
      return window.app.user.account
    },
  },
  watch: {
    radish: {
      async handler(val, oldVal) {
        this.testPaper = Object.assign({}, getQuestions(val['职能模块']))
        this.tagsChanged = false

        val && val._id && this.getTestPaper(val)
      },
      immediate: true,
      deep: true,
    },
    remark: {
      async handler(val, oldVal) {
        const remark = val || []
        const formatResult = {}
        remark.map(item => {
          const { answer, stem, time, user } = item
          const date = dateFormat(new Date(parseInt(time, 10)), 'yyyy-mm-dd HH:MM')
          const group = `${date}--${user}`
          if (!formatResult[group]) formatResult[group] = []
          formatResult[group].push({
            answer,
            stem,
            time,
            user,
          })
        })
        this.remarkGroup = formatResult
      },
      immediate: true,
    },
    otherRemark(newVal) {
      const unsave = app.root.$refs.radishDetailTab.unsave
      const name = this.radish['姓名']
      if (newVal) {
        app.root.$refs.radishDetailTab.unsave[this.radish._id] = name
      } else {
        delete app.root.$refs.radishDetailTab.unsave[this.radish._id]
      }
    },
  },
  methods: {
    async getTestPaper(newRadish) {
      try {
        const radish = (newRadish && _.cloneDeep(newRadish)) || (this.radish && _.cloneDeep(this.radish))
        const data = await window.app
          .service('communication')
          .testPaper({ radishId: radish._id, category: radish['职能模块'] })
        this.parseData(data, radish)
        this.getRemarkLocal()
        if (!data) return
        this.remark = data.remark || []
        ;(this.tags || []).map((tagGroup, index) => {
          if (data.tags && data.tags.length > 0) {
            const dataTag = data.tags.filter(t => t.label === tagGroup.label)
            tagGroup.checkList = dataTag.length > 0 ? dataTag[0].checkList : []
          } else {
            tagGroup.checkList = []
          }
        })
        this.answerCardModal = _.cloneDeep(data || {})
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    parseData(data, radish) {
      try {
        const testPaper = this.testPaper
        const categories = Object.keys(testPaper)
        categories.map(category => {
          const ques = testPaper[category] || []
          ques.map(question => {
            const { id, link, options } = question
            switch (link) {
              case '细分职能':
                question.answer = ((Array.isArray(radish['细分职能']) && radish['细分职能']) || []).map(val => {
                  for (const key in options) {
                    if (options[key] === val) {
                      return key
                    }
                  }
                })
                break
              case '擅长方向':
                question.answer = ((Array.isArray(radish['擅长方向']) && radish['擅长方向']) || []).map(val => {
                  for (const key in options) {
                    if (options[key] === val) {
                      return key
                    }
                  }
                })
                break
              case '职级':
                question.answer = zhijiOptionKey[radish['职级']]
                break
              case '微信':
                question.text = radish['微信'] || ''
                break
              case '业绩':
                question.answer = yejiOptionKey[radish['业绩']]
                break
              case '长期意向':
                question.answer = radish['长期意向'] === 'Y' ? 'A' : radish['长期意向'] === 'N' ? 'C' : ''
                break
              default:
                break
            }
            if (data && data[id]) {
              question = Object.assign(question, data[id])
            }
          })
        })
        if (data && data[1]) {
          this.changeCommonQues(data[1].answer)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    onChanges({ item, option, text }, category) {
      const { stem, type, link, textLink, options, answer } = item
      !this.changes[stem] && (this.changes[stem] = { link, textLink, options, answer })
      if (type === 'multible' || type === 'radio') {
        this.changes[stem].answer = answer
        text !== undefined && (this.changes[stem].text = text.trim())
      }
      if (type === 'input' && text) {
        const _text = text.trim()
        const oldAnswer = this.answerCardModal[stem]
        ;(!oldAnswer || oldAnswer.text !== _text) && (this.changes[stem].text = _text)
      }
      if (type === 'sort') {
        const oldAnswer = this.answerCardModal[stem]
        text !== undefined && (this.changes[stem].text = text.trim())
        ;(!oldAnswer || oldAnswer.answer.toString() !== answer.toString()) && (this.changes[stem].answer = answer)
      }
    },
    // TODO
    async save(param) {
      const { testPaper, radish, tags } = this
      const remark = []
      const id = radish._id
      if (!id) return {}
      const { changes, otherRemark } = this
      const stems = Object.keys(changes) || []
      const _otherRemark = otherRemark && otherRemark.trim()
      if (!this.tagsChanged && !_otherRemark && stems.length === 0) return {}
      try {
        const user = app.user.提供者 || app.user.account
        const time = Date.now()
        const linkChanges = {}
        stems.forEach(stem => {
          const changedItem = changes[stem]
          const { link, textLink, answer, text, options } = changedItem
          if (link === '沟通备注' || textLink === '沟通备注') {
            remark.push({
              stem,
              answer: this.formatCommon(stem, options, answer, text),
              time,
              user,
            })
          }
          const linkChange = this.formatLinkData(changedItem)
          if (!linkChange) return {}
          if (linkChange.field === '个性标签') {
            !linkChanges['个性标签'] && (linkChanges['个性标签'] = '')
            linkChanges['个性标签'] += (linkChange.val && `${linkChange.val}`) || ''
          } else {
            linkChanges[linkChange.field] = linkChange.val
          }
        })
        const answerCard = {}
        const commonQues = testPaper.common
        ;(commonQues || []).forEach(question => {
          const { text, answer, link } = question
          if (text || (answer && answer.length > 0)) {
            !answerCard[question.id] && (answerCard[question.id] = {})
            answerCard[question.id].link = link
            answer && answer.length > 0 && (answerCard[question.id].answer = answer)
            text && (answerCard[question.id].text = text.trim())
          }
        })
        const dataKeys = Object.keys(testPaper)
        ;(dataKeys || []).forEach(key => {
          if (radish['职能模块'] && radish['职能模块'].includes(key)) {
            const ques = testPaper[key]
            ques.forEach(question => {
              const { text, answer, link } = question
              if (text || (answer && answer.length > 0)) {
                !answerCard[question.id] && (answerCard[question.id] = {})
                answerCard[question.id].link = link
                answer && answer.length > 0 && (answerCard[question.id].answer = answer)
                text && (answerCard[question.id].text = text.trim())
              }
            })
          }
        })

        if (_otherRemark) {
          remark.push({
            stem: '沟通记录',
            answer: _otherRemark,
            time,
            user,
          })
        }
        answerCard.remark = remark
        if (tags && tags.length > 0) {
          answerCard.tags = tags.map(({ label, checkList }) => ({
            label,
            checkList,
          }))
        }
        answerCard.radishId = id
        await app.service('communication').upsert(answerCard)
        this.addKpi({ rid: id })
        this.otherRemark = ''
        this.tagsChanged = false
        this.clearRemarkLocal()
        await this.getTestPaper()

        if (linkChanges['个性标签']) {
          linkChanges['个性标签'] = (this.radish['个性标签'] || '') + linkChanges['个性标签']
        }
        // if (this.remark.length > 0) {
        //   let remarkText = ''
        //   for (let i = this.remark.length - 1; i >= 0; i -= 1) {
        //     const val = this.remark[i]
        //     if (!val) break
        //     remarkText += `${dateFormat(new Date(parseInt(val.time, 10)), 'yyyy-mm-dd') + val.user + val.answer}；`
        //   }
        //   linkChanges['沟通日志'] = remarkText
        // }
        const q6 = commonQues[6]
        let zp = ''
        if (q6 && q6.answer) zp += `${q6.options[q6.answer]};`
        if (q6 && q6.text) zp += `${q6.text};`
        if (zp) linkChanges['业绩自评'] = zp
        const q7 = commonQues[7]
        let qx = ''
        if (q7 && q7.answer && q7.answer.length > 0) {
          q7.answer.forEach(option => {
            qx += `${option};`
          })
        }
        if (q7 && q7.text) qx += `${q7.text};`
        const q8 = commonQues[8]
        if (q8 && q8.answer) qx += q8.options[q8.answer]
        if (qx) linkChanges['倾向'] = qx
        this.changes = {}
        if (param && param.only) {
          this.onSave(linkChanges)
        }
        return linkChanges
      } catch (error) {
        this.$message.error(error.message)
        return {}
      }
    },
    addKpi(content) {
      // type: 电话 推荐 面试 offer content: 需要记录的内容如rid姓名等
      app.service('radish').addKpi({
        type: '电话',
        content,
      })
    },
    formatLinkData(changedItem) {
      const { link, options, answer, text } = changedItem
      let val
      switch (link) {
        case '业绩':
          val = formatYeji[answer]
          break
        case '职级':
          val = formatZhiji[answer]
          break
        case '细分职能':
          val = answer.map(val => options[val])
          break
        case '擅长方向':
          val = answer.map(val => options[val])
          break
        case '个性标签':
          val = ''
          if (Array.isArray(answer)) {
            answer.map(val => {
              for (const key in options) {
                if (key === val) {
                  val += `${options[key]}`
                }
              }
            })
          } else {
            for (const key in options) {
              if (key === answer) {
                val = `${options[key]}`
              }
            }
          }
          if (text && text.trim()) {
            val += `${text}`
          }
          val = val.replace(/（.*?）/g, '')
          break
        case '长期意向':
          val = answer === 'A' ? 'Y' : answer === 'C' ? 'N' : ''
          break
        case '微信':
          val = answer === 'B' ? text : '手机'
          break
        default:
          val = answer
          break
      }
      return link
        ? {
            field: link,
            val,
          }
        : null
    },
    onSelect(item, option, _index) {
      const { type, answer } = item
      if (type === 'multible') {
        const index = (answer || []).findIndex(val => val === option)
        if (index > -1) {
          answer.splice(index, 1)
        } else {
          !item.answer && (item.answer = [])
          item.answer.push(option)
        }
      } else if (answer === option) {
        item.answer = ''
      } else {
        item.answer = option
      }
      this.onChanges({ item, option })
      if (_index === 0) {
        this.changeCommonQues(item.answer)
      }
    },
    addTag(item, tag) {
      const { answer } = item
      if (!answer) item = Object.assign({}, item, { answer: [] })
      const index = item.answer.findIndex(val => val === tag)
      if (index > -1) return
      item.answer.push(tag)
      this.onChanges({ item })
    },
    removeTag(item, tag) {
      item.answer.splice(item.answer.indexOf(tag), 1)
    },
    changeCommonQues(option) {
      const commonQues = this.testPaper.common
      if (option === 'B') {
        commonQues[1].hidden = false
        commonQues[2].hidden = false
        commonQues[3].hidden = false
        commonQues[7].hidden = true
      }
      if (option === 'A') {
        commonQues[1].hidden = true
        commonQues[2].hidden = true
        commonQues[3].hidden = true
        commonQues[7].hidden = false
      }
    },
    removeRemark(value) {
      const answer = value && value.answer.substr(0, 50)+'...'
      this.$confirm(`确定删除沟通日志：“${answer}”吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await app.service('communication').removeRemark({ radishId: this.radish._id, answer: value })
          arrRemove(
            this.remark,
            item =>
              item.stem === value.stem &&
              item.answer === value.answer &&
              item.time === value.time &&
              item.user === value.user,
          )
        })
        .catch(e => {
          console.log(e)
        })
    },

    // TODO: 封装，start 标签相关
    removeOtherTag(tag) {
      const _tags = this.tags
      _tags.map(tagGroup => {
        if (tagGroup.key === 'other') {
          const checkList = tagGroup.checkList
          checkList.splice(checkList.indexOf(tag), 1)
        }
      })
    },
    handleInputConfirm(index) {
      const inputValue = this.inputValue
      if (inputValue) {
        const _tags = this.tags
        _tags.map(tagGroup => {
          if (tagGroup.key === 'other') {
            tagGroup.checkList.push(inputValue)
          }
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput && this.$refs.saveTagInput[0].$refs.input.focus()
      })
    },
    async showFollow() {
      await app.service('project').saveRecords({ type: '待跟进', path: '人选会谈-沟通日志', page: '人选详情' })
      this.$refs.followDialog.show(this.radish)
    },
    async showRec() {
      await app.service('project').saveRecords({ type: '推荐给他人', path: '人选会谈-沟通日志', page: '人选详情' })
      this.$refs.recDialog.show({ _id: this.radish._id, 姓名: this.radish['姓名'] })
    },
    onTagchange() {
      if (!this.tagsChanged) this.tagsChanged = true
    },
    formatCommon(stem, options, answer, text) {
      const answerText = text ? `${text}` : ''
      const answerContent = ((answer && ((options && options[answer]) || answer.toString())) || '').replace(
        /（.*?）/g,
        '',
      )
      let res = ''
      const l = answerContent && answerText ? '（' : ''
      const r = answerContent && answerText ? '）' : ''
      // 人类 愚蠢
      switch (stem) {
        case '你有朋友介绍吗？':
          res = `朋友介绍:${answerText}`
          break
        case '抛开这个机会不说，您最理想的机会是什么样的？或者以下的因素您怎么排序呢？或者您内心有没有目标机构呢？ ':
          res = `理想机会:${answerContent}${answerText ? `。意向机构:${answerText}` : ''}`
          break
        case '您对他们公司熟悉吗？之前有接触过吗？':
          res = answerContent
          break
        case '您现在还有别的机会在接触吗？分别是哪些公司？具体岗位？进展到什么阶段了？':
          res = `在接触的机会:${answerText}`
          break
        case '您怎么看这个市场？您怎么看**（该人选所从事方向）业务的发展趋势？':
          res = `对市场${answerContent}${l}${answerText}${r}`
          break
        case '您现在主要看机会的原因是？新的机会你希望和现在有什么不同？':
          res = `看机会原因:${answerContent}${l}${answerText}${r}`
          break
        case '如果机会非常合适的话，您是一定会走吗，以及您的离职周期':
          const answerMap = {
            A: '机会合适一定会走',
            B: '机会合适的话不一定会走',
            C: '机会合适看情况离职',
          }
          res = (answer ? answerMap[answer] : '') + (answerText ? `。离职周期:${answerText}` : '')
          break
        case '本次沟通中，候选人都问到了以下哪些问题？':
          res = `人选提到了:${answerContent}${l}${answerText}${r}`
          break

        default:
          res = answerContent + l + answerText + r
          break
      }
      return res
    },
    formatAnswer(answer) {
      if (!answer) return ''
      return answer.replace(/\n+/g, '<br/>').replace(' ', '&nbsp;')
    },
    autoSaveRemarkLocal() {
      localStorage[`remark${this.radish._id}`] = this.otherRemark
    },
    getRemarkLocal() {
      const remark = localStorage[`remark${this.radish._id}`]
      if (remark) this.otherRemark = remark
    },
    clearRemarkLocal() {
      localStorage[`remark${this.radish._id}`] = ''
    },
  },
}
</script>

<style>
.testpaper2 .el-collapse-item__header {
  padding-left: 10px;
}
.comm-wrapper {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.cell-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.testpaper2 .question {
  padding: 0 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.question .el-radio + .el-radio {
  margin-left: 0;
}
.check-icon {
  border-radius: 50%;
  color: #fff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  padding: 2px;
}
.check-blue {
  background-color: #409eff;
  border-color: #409eff;
}
.comm-handler {
  position: fixed;
  right: 20px;
  bottom: 20px;
}
.sort-box {
  margin: 0 -5px;
}
.sort-tag {
  margin: 5px;
}
.question-option {
  cursor: pointer;
}
.question-option:hover {
  color: #409eff;
}
.tag-wrapper .el-checkbox + .el-checkbox,
.question .el-checkbox + .el-checkbox {
  margin-left: 0;
}
.collapse-item-title {
  color: #409eff;
}
.remark-item {
  line-height: 1.5;
  padding-top: 3px;
  padding-left: 5px;
}
.remark-info {
  display: flex;
  position: relative;
  padding-left: 15px;
}
.remark-info .el-icon-info,
.remark-info .el-icon-delete {
  position: absolute;
  left: 0;
  top: 3px;
}
.remark-info .el-icon-delete {
  display: none;
  color: #f56c6c;
  cursor: pointer;
}
.remark-self .remark-info:hover {
  color: #f56c6c;
}
.remark-self .remark-info:hover .el-icon-delete {
  display: block;
}
.remark-self .remark-info:hover .el-icon-info {
  display: none;
}
.remark-date {
  color: #aaa;
}
.question .input-new-tag .el-input__inner {
  height: 24px;
  line-height: 24px;
}
.question .button-new-tag {
  width: 100px;
  padding: 5px 15px;
}
.button-new-tag i {
  color: #409eff;
}
.remark-time {
  color: #aaa;
}
.testpaper-textarea {
  position: relative;
}
.testpaper-textarea .el-textarea__inner {
  padding-bottom: 24px;
}
</style>
